import { PortalTabs } from "@portal/Components/Portal/PotalTabs/PotalTabs";
import { Tiles } from "@portal/Components/Portal/Tiles/Tiles";

function Portal() {
  return (
    <>
      <Tiles />
      <PortalTabs />
    </>
  );
}

export default Portal;
